import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useRouteError } from 'react-router-dom';
import { ErrorFallback, reportRenderError } from 'src/components/ApplicationErrorBoundary';
import { getApplicationSettings } from 'src/modules/applications/slices';
import { useErrorRecovery } from 'src/hooks/useErrorRecovery';

const RouteErrorBoundary = () => {
  const error = useRouteError();
  const location = useLocation();
  const settings = useSelector(getApplicationSettings);
  const { recover, recoveryActionLabel, showRecoveryAction } = useErrorRecovery();

  useEffect(() => {
    reportRenderError(error, `route:${location.pathname}${location.search}`);
  }, [error, location.pathname, location.search]);

  return (
    <ErrorFallback
      settings={settings}
      onReload={() => window.location.reload()}
      onRecover={recover}
      recoveryActionLabel={recoveryActionLabel}
      showRecoveryAction={showRecoveryAction}
    />
  );
};

export default RouteErrorBoundary;
